import { Modal, Box, Typography, Button, Stack } from "@mui/joy";

interface ModalConfirmProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
  caption?: string;
}

export default function ModalConfirm({
  open,
  onClose,
  onConfirm,
  title = "Confirm Action",
  description = "Are you sure you want to proceed?",
  caption,
}: ModalConfirmProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          p: 3,
          borderRadius: 2,
          backgroundColor: "background.body",
          maxWidth: 400,
          mx: "auto",
          mt: "20vh",
        }}
      >
        <Typography level="h4" mb={1}>
          {title}
        </Typography>
        <Typography level="body-sm" mb={2}>
          {description}
        </Typography>
        {
          caption &&
          <Typography level="body-sm" mb={2}>
            {caption}
          </Typography>
        }
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="plain" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="solid" color="primary" onClick={onConfirm}>
            Confirm
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}
